// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTechnologyGit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m12.935 1.896 9.169 9.169a1.353 1.353 0 0 1 0 1.913l-9.126 9.126a1.353 1.353 0 0 1-1.913 0l-9.169-9.169a1.353 1.353 0 0 1 0-1.913l9.126-9.126a1.352 1.352 0 0 1 1.913 0zm-.956 1.872-1.446 1.446 1 1.001a1.606 1.606 0 0 1 2.035 2.048l2.327 2.328a1.609 1.609 0 1 1-.964.907l-2.17-2.171v5.713a1.61 1.61 0 1 1-1.323-.047V9.227a1.61 1.61 0 0 1-.874-2.11l-.967-.967-5.83 5.829 8.255 8.253 8.21-8.21z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTechnologyGit;
